import {Component} from "react";
import {accountService} from "./Account.service";
export default class LogOut extends Component {
    render(){
        accountService.logout();
        window.location.replace(process.env.REACT_APP_MYAPP);
        return true;
    }
}